import React from 'react';
import './styles.scss';

const Drawer = ({ title, hidden, onClose, customModal, body }) => {
  return (
    <div id="drawer" className={`drawer side-menu ${hidden ? 'hidden' : ''}`}>
      <div className="drawer-header">
        <h3>{title}</h3>
        <button className="btn" onClick={onClose}>
          <i className="uil uil-multiply" />
        </button>
      </div>
      <div className="drawer-body">{body}</div>
      {customModal}
    </div>
  );
};

export default Drawer;
